import { useMemo } from "react";
import { useKnowledgeBaseList } from "@/contexts/KnowledgeBaseContext";
import {
  getDriveSyncStatus,
  type DriveSyncStatus,
} from "@/lib/googleDriveKbLink";
import type { DriveEntry } from "@/services/googleDriveService";

export type DriveFileSyncInfo = {
  status: DriveSyncStatus;
  kbDocId?: string;
};

export function useGoogleDriveSyncMap(files: DriveEntry[]) {
  const { items: kbItems } = useKnowledgeBaseList();

  return useMemo(() => {
    const map = new Map<string, DriveFileSyncInfo>();
    for (const file of files) {
      if (file.isFolder) continue;
      const { status, kbDocId } = getDriveSyncStatus(
        file.id,
        file.modifiedTime,
        kbItems
      );
      map.set(file.id, { status, kbDocId });
    }
    return map;
  }, [files, kbItems]);
}
